import Logger from "../Logger";
import SignalTypes from "../models/SignalTypes";
import { noItx } from "../translationItx/itx";
import AddressGeneratorUtils from "./AddressGeneratorUtils";

const logger = new Logger();

export function linkEnvironmentsSignals() {
  state.allDevices().forEach((device) => {
    device.knxChannels.forEach((knxChannel) => {
      knxChannel.signals.forEach((knxSignal) => {
        if (knxSignal.type.globalGroupAdress) {
          const requestChannel = knxChannel.requestChannel;
          const signal1 = requestChannel?.getSignalByNumber(knxSignal.number);
          let groupAddressIndividuell = signal1?.groupAddresses.items.find(
            (ga) => ga.fullAddress != knxSignal.type.globalGroupAdress,
          );

          const operationModeTypes = [
            SignalTypes.OperationMode.name,
            SignalTypes.OperationMode_Comfort.name,
            SignalTypes.OperationMode_Eco.name,
            SignalTypes.OperationMode_FrostProtection.name,
            SignalTypes.OperationMode_HeatProtection.name,
            SignalTypes.OperationMode_Night.name,
            SignalTypes.OperationMode_Status.name,
          ];

          if (operationModeTypes.includes(knxSignal.type.name)) {
            //
            // den HAVC OperationMode/Status binden wir auch, "wenn schon eine Taster eine Gruppenaddresse gesetzt hat" (linkActorsChannel)
            //
            // So kann der HCAV OperationMode sowohl global,
            // als auch nur für einen einzelnen Heizkanal werden
            //

            if (device.isActor) {
              //
              // Tasten können nur den globalen OperationMode setzen oder für einen Channel
              // daher hier nichts tun, und somit die globele GA NICHT verlinken wenn schon eine individuelle gesetzt wurde.
              //
              groupAddressIndividuell = undefined;
            }
          }

          if (groupAddressIndividuell) {
            // we already have a (indiviual) signal with this type in the request channel
            // so we do not need to link to an environment group address
            //
            // DO NOTHING here
            logger.log(
              "GroupAddress alread attached to Signal: " + // no itx
                signal1?.name +
                " " +
                groupAddressIndividuell.fullAddress +
                " " +
                groupAddressIndividuell.name,
            ); // no itx
          } else {
            const aa = knxSignal.type.globalGroupAdress.split("/");
            const groupAddress = state.addresses
              .findFirst((a1) => a1.address == aa[0])
              ?.children.findFirst((a2) => a2.address == aa[1])
              ?.children.findFirst((a3) => a3.address == aa[2]);

            if (groupAddress) {
              AddressGeneratorUtils.attachGroupAddressToSignal(knxSignal, groupAddress);
            } else {
              logger.error(
                noItx("Signal has no groupAdress: ") +
                  knxSignal.type.name +
                  " " +
                  knxChannel.fullTag +
                  " GA: " + // no itx
                  knxSignal.type.globalGroupAdress,
              ); // no itx
            }
          }
        }
      });
    });
  });
}
